import { render, staticRenderFns } from "./ChangeSize.vue?vue&type=template&id=073b21ad&"
import script from "./ChangeSize.vue?vue&type=script&lang=js&"
export * from "./ChangeSize.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSize.vue?vue&type=style&index=0&id=073b21ad&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports